




























import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import BaseComponent from "@/core/components/BaseComponent";
import {Measurement} from "@/core/services/MedicaPro/models";
import {Api} from "@/core/services/MedicaPro/Api";

@Component({
    components: {
    }
})
export default class MeasurementListEditCommentDialog extends BaseComponent {

    // Bindings to parent (Modals.vue)
    @Prop() item!: Measurement | null;

    // Bindings to view
    public dialog = false;
    public isSaving = false;
    public isReady = false;
    public value = '';

    // Data

    // <editor-fold desc="Load data">

    public mounted() {
        this.itemIdChanged();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    @Watch("item")
    private itemIdChanged() {
        this.unsubscribeAll();
        this.loadItem();
    }

    private loadItem() {
        if (this.item == null) {
            // Ignore
        } else {
            this.renderItem();
            this.dialog = true;
        }
    }

    private renderItem() {
        this.value = this.item?.comment ?? '';
        this.isReady = true;
    }

    // </editor-fold>

    // <editor-fold desc="View Actions">

    public close() {
        this.dialog = false;
    }

    public save() {
        this.isSaving = true;
        this.item!.comment = this.value;
        Api.measurements().patchById(this.item!.id!)
            .save(this.item!, item => {
                this.isSaving = false;
               this.close();
            });
    }

    // </editor-fold>

}
